__turbopack_context__.v({
  "root": "tweet-body-module__Dcfe9a__root",
});
